import { AcceptorLoginResponse } from "@/interfaces/acceptor-login-response.interface";
import { LoginResponse } from "@/interfaces/login-response.interface";
import { Roles } from "@/types/roles.type";

export const AuthTokenTimestamp = (acceptor = false): boolean => {
    try {
        if (acceptor === false) {
            const accountStr = localStorage.getItem('account');
            if (!accountStr) {
                return false;
            }
            const account = JSON.parse(accountStr) as LoginResponse;
            const authTokenTimestamp = account.tokenTimestamp ?? 0;
            return ((new Date().getTime() - authTokenTimestamp) / 1000 / 60) <= process.env.VUE_APP_AUTH_CHECK_MINUTE ?? -1;
        }
        const accountStr = sessionStorage.getItem('acceptor_account');
        if (!accountStr) {
            return false;
        }
        const account = JSON.parse(accountStr) as AcceptorLoginResponse;
        const authTokenTimestamp = account.tokenTimestamp ?? 0;
        return ((new Date().getTime() - authTokenTimestamp) / 1000 / 60) <= process.env.VUE_APP_AUTH_CHECK_MINUTE ?? -1;
    } catch (error) {
        return false;
    }
};

export const AuthToken = (acceptor = false): string => {
    try {
        if (acceptor == false) {
            const accountStr = localStorage.getItem('account');
            if (!accountStr) {
                throw 'Account not found';
            }
            const account = JSON.parse(accountStr) as LoginResponse;
            return `Bearer ${account.token}`;
        }
        const accountStr = sessionStorage.getItem('acceptor_account');
        if (!accountStr) {
            throw 'Account not found';
        }
        const account = JSON.parse(accountStr) as AcceptorLoginResponse;
        return `Bearer ${account.token}`;
    } catch (error) {
        return '';
    }
};

export const AuthRole = (acceptor = false): Roles => {
    try {
        if (acceptor == false) {
            const accountStr = localStorage.getItem('account');
            if (!accountStr) {
                throw 'Account not found';
            }
            const account = JSON.parse(accountStr) as LoginResponse;
            return account.role;
        }
        const accountStr = sessionStorage.getItem('acceptor_account');
        if (!accountStr) {
            throw 'Account not found';
        }
        const account = JSON.parse(accountStr) as AcceptorLoginResponse;
        return account.role;
    } catch (error) {
        return 'NONE';
    }
};